module.exports = __webpack_public_path__ + "static/pool-b5adb698830ba965770cc5f3cae96584.mp4";